import { Award, BookOpen, TrendingUp, Users } from "lucide-react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
export default function WhyChooseGenesisInversores() {
  const benefits = [{
    id: 1,
    icon: Award,
    title: "Instrucción de Expertos",
    description: "Aprende de profesionales con más de 10 años de experiencia en mercados internacionales y análisis técnico y fundamental."
  }, {
    id: 2,
    icon: TrendingUp,
    title: "Enfoque Práctico",
    description: "Capacitación basada en casos reales del mercado estadounidense con herramientas analíticas y software financiero profesional."
  }, {
    id: 3,
    icon: BookOpen,
    title: "Contenido Actualizado",
    description: "Acceso a recursos educativos constantemente actualizados que reflejan las últimas tendencias del mercado de valores."
  }, {
    id: 4,
    icon: Users,
    title: "Soporte Personalizado",
    description: "Seguimiento individualizado y asesoramiento continuo durante todo tu proceso de aprendizaje e inversión."
  }];
  return <section className="relative overflow-hidden bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1401256/img/wall_street_bull_bronze_statue.png)] py-16 md:py-24">
      {}
      <div className="absolute inset-0 bg-black/70" />
      
      <div className="container mx-auto max-w-7xl px-6 lg:px-8 relative z-10">
        <div className="mx-auto mb-12 max-w-3xl text-center animate-fade-in-up">
          <h2 className="mb-4 text-3xl font-semibold tracking-wide text-white md:text-4xl lg:text-5xl">
            ¿Por Qué Elegir Zafiro Investments?
          </h2>
          <p className="text-base leading-relaxed text-white/90 md:text-lg">
            Descubre las ventajas de formarte con nosotros. Ofrecemos educación financiera de calidad, 
            adaptada para hispanohablantes que desean dominar el mercado de valores estadounidense con 
            confianza y conocimiento sólido.
          </p>
        </div>

        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {benefits.map((benefit, i) => {
          const IconComponent = benefit.icon;
          return <Card key={benefit.id} data-index={i} className="border border-border bg-white shadow-soft transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-1 hover:shadow-medium">
                <CardHeader className="pb-4">
                  <div className="mb-3 inline-flex size-12 items-center justify-center rounded-md bg-primary/10">
                    <IconComponent className="size-6 text-primary" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-lg font-semibold text-foreground">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-sm leading-relaxed text-muted-foreground">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>;
        })}
        </div>

        <div className="mt-12 flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Button className="font-bold !bg-transparent border-2 border-white text-white underline hover:bg-white/10 shadow-medium transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 hover:shadow-strong">CLASE EN VIVO CON EL PROFESOR JUAN AQUÍ</Button>
          <Button className="font-bold bg-white text-foreground hover:bg-white/90 shadow-medium transition-all duration-[var(--duration-medium)] hover:-translate-y-0.5 hover:shadow-strong underline">CLASE EN VIVO CON EL PROFESOR VLAD AQUÍ</Button>
        </div>
      </div>
    </section>;
}